import { render, staticRenderFns } from "./UserSelectPopupWrappable.vue?vue&type=template&id=45af0f00&scoped=true&lang=pug&"
import script from "./UserSelectPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./UserSelectPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectPopupWrappable.vue?vue&type=style&index=0&id=45af0f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af0f00",
  null
  
)

export default component.exports